import { Observable, of, timer } from 'rxjs';
import { CustomAsyncValidatorFn } from '@shared/form-elements/model/form-elements.model';
import { map, shareReplay, switchMap, take } from 'rxjs/operators';

export const membershipValidator =
    (clubService: { validateMember: (email: string) => Observable<boolean> }): CustomAsyncValidatorFn =>
    control => {
        const email = control.value;

        if (!email) {
            // Does not check for 'required', use separate validator
            return of(null);
        }
        return timer(500).pipe(
            switchMap(() => clubService.validateMember(email)),
            map(response => {
                return response ? null : { invalidMembershipEmail: true as const };
            }),
            take(1),
            shareReplay({
                bufferSize: 1,
                refCount: true
            })
        );
    };
